export const frontendUrl = process.env.NEXT_PUBLIC_FRONTEND_URL!
